<template>
  <page-wrap>
    <layout :isEmpty="false" :messageEmpty="L10n('select-a-part')">
      <template v-slot:header>
        <h1 class="page-title">{{pageTitle}}</h1>
      </template>
      <template v-slot:tools>
        <tools-panel
          :poStillOpen="poStillOpen"
          :itemID.sync="salesOrderID"
          @on-add-new="handleNew"
          @on-changed="handlerChange"
        />
      </template>
      <template v-slot:content>
        <data-provider :salesOrderID="salesOrderID" editorID="rfqID">
          <template>
            <editor
              :salesOrderID="salesOrderID"
              :poStillOpen="poStillOpen"
              :config="{id: 'rfqID', api: 'RFQs/Get/'}"
            />
          </template>
        </data-provider>
      </template>
    </layout>
  </page-wrap>
</template>

<script>
export default {
  name: 'SupplierPoRFQ2Index',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'tools-panel': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './ToolsPanel'),
    'layout': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PagePanel'),
    'editor': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './Editor'),
    'data-provider': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './DataProvider')
  },
  props: {
    poStillOpen: { type: Boolean, required: true }
  },
  created () {
    let value = this.$route.query[this.editorID] || ''
    let start = value.indexOf('[')
    let end = value.indexOf(']')

    if (start !== -1 && end !== -1) {
      value = Number(value.slice(start + 1, end))
      this.salesOrderID = isNaN(value) ? null : value
    }
  },
  data () {
    return {
      salesOrderID: null,
      editorID: 'supplier-quotes-rfq2-chosen-true'
    }
  },
  computed: {
    pageTitle () {
      return this.L10n(this.$route.meta.label)
    }
  },
  methods: {
    handlerChange () {
      if (this.salesOrderID) {
        this.edit()
      } else {
        this.close()
      }
    },
    handleNew () {
      let query = { 'supplier-quotes-rfq2-chosen-false': 'new' }
      this.$router.push({ name: 'SupplierQuotesRFQ2ChosenFalse', query })
    },
    edit () {
      let query = Object.assign({}, this.$route.query, { [this.editorID]: `edit[${this.salesOrderID}]` })
      this.$router.replace({ query })
    },
    close () {
      let query = Object.assign({}, this.$route.query)
      delete query[this.editorID]
      this.$router.replace({ query })
    }
  }
}
</script>
